import { ErrorMessageQuery } from '@shared/lib/utils/get-query-error/types';
import { OrderListItem } from '@shared/model/order';
import { STATUS_MAP } from './statuses';

export const orderErrorByStatus = (order: OrderListItem | undefined) => {
    if (order?.status && order.status !== 'order_forming') {
        return {
            message: `Изменение сделки в статусе "${STATUS_MAP[order.status]}" невозможно`,
            status: 403,
        } as ErrorMessageQuery;
    }
};
